/*
 Plugin Name: Scroll Direction
 Plugin URI: http://www.interconnectit.com
 Description: Set The Scroll direction as a class on the body tag
 Version: 1.0
 Author: interconnect/it
 Author URI: http://www.interconnectit.com
 */

// Set a css custom property on the body tag to -1 or 1 depending on the direction of scroll
let lastScroll = 0;
document.addEventListener( 'scroll', () => {
    // Use with @container style(--scroll-dir: up) { ... } in CSS
    document.body.style.setProperty( '--scroll-dir', window.scrollY - lastScroll <= 0 ? 'up' : 'down' );
//    document.body.style.setProperty( '--scroll-y', window.scrollY + 'px' );

    // Add a class to the body tag to indicate the scroll direction
    // @todo When "@container style()" is 100% available remove this.
    document.body.classList.remove( window.scrollY - lastScroll <= 0 ? 'scroll-down' : 'scroll-up' );
    document.body.classList.add( window.scrollY - lastScroll <= 0 ? 'scroll-up' : 'scroll-down' );

    lastScroll = window.scrollY;
} );
